export default __webpack_public_path__ + "static/media/supportIcon.66e97113.svg";